/* Trade Titans Direct — shared behaviour */
(function () {
  'use strict';

  /* ---------------- Brand directory: search, group filter, A-Z jump --------- */
  function initBrands() {
    var search = document.getElementById('brandSearch');
    if (!search) return;
    var chips  = Array.prototype.slice.call(document.querySelectorAll('.chip'));
    var cards  = Array.prototype.slice.call(document.querySelectorAll('.bcard'));
    var groups = Array.prototype.slice.call(document.querySelectorAll('.azgroup'));
    var noRes  = document.getElementById('noResult');
    var active = 'all';

    function apply() {
      var q = (search.value || '').trim().toLowerCase();
      var any = false;
      cards.forEach(function (c) {
        var okCat = active === 'all' || c.dataset.cat === active;
        var okQ   = !q || c.dataset.name.indexOf(q) > -1;
        var show  = okCat && okQ;
        c.hidden = !show;
        if (show) any = true;
      });
      groups.forEach(function (g) {
        g.hidden = !g.querySelector('.bcard:not([hidden])');
      });
      if (noRes) noRes.hidden = any;
    }

    search.addEventListener('input', apply);
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.remove('on'); });
        ch.classList.add('on');
        active = ch.dataset.filter;
        apply();
      });
    });
    document.querySelectorAll('.azlink').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.querySelector('.azgroup[data-letter="' + a.dataset.jump + '"]');
        if (t) t.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  /* ---------------- Hero: quote request line builder ----------------------- */
  function initRequest() {
    var lines = document.getElementById('qlines');
    if (!lines) return;
    var addBtn = document.getElementById('qadd');
    var info   = document.getElementById('qlineinfo');
    var badge  = document.getElementById('quoteCount');
    var err    = document.getElementById('qerr');
    var form   = document.getElementById('requestForm');
    var body   = document.getElementById('rq_body');

    function row() {
      return '<div class="qgrid qline">' +
        '<input class="qin" placeholder="EAN / barcode" inputmode="numeric" aria-label="EAN">' +
        '<input class="qin" placeholder="0.00" inputmode="decimal" aria-label="Target price">' +
        '<input class="qin" placeholder="0" inputmode="numeric" aria-label="Quantity">' +
        '<button type="button" class="qdel" aria-label="Remove line">&times;</button></div>';
    }
    var card = document.getElementById('request');
    var d = (card && card.dataset) || {};
    var WORD_ONE  = d.lineSingular || 'line';
    var WORD_MANY = d.linePlural   || 'lines';

    function refresh() {
      var all = lines.querySelectorAll('.qline');
      var n = all.length, filled = 0;
      all.forEach(function (l) { var i = l.querySelector('.qin'); if (i && i.value.trim()) filled++; });
      if (info)  info.textContent = n + ' ' + (n === 1 ? WORD_ONE : WORD_MANY);
      if (badge) badge.textContent = String(filled);
    }
    /* typing an EAN, or adding one from the catalogue, updates the header count */
    lines.addEventListener('input', refresh);
    if (addBtn) addBtn.addEventListener('click', function () {
      lines.insertAdjacentHTML('beforeend', row());
      refresh();
    });
    lines.addEventListener('click', function (e) {
      var d = e.target.closest('.qdel');
      if (!d) return;
      if (lines.querySelectorAll('.qline').length > 1) { d.closest('.qline').remove(); refresh(); }
    });

    function mark(el, bad) { if (el) el.classList.toggle('invalid', bad); return !bad; }
    function fail(msg) { if (err) { err.textContent = msg; err.classList.add('show'); } }

    if (form) form.addEventListener('submit', function (e) {
      if (err) err.classList.remove('show');
      var name  = document.getElementById('rq_name');
      var co    = document.getElementById('rq_co');
      var email = document.getElementById('rq_email');
      var ok    = document.getElementById('rq_ok');
      var valid = true;

      valid = mark(name, !name.value.trim()) && valid;
      valid = mark(co,   !co.value.trim())   && valid;
      valid = mark(email, !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim())) && valid;

      if (!valid) { e.preventDefault(); fail(d.errContact || 'Please add your name, company and a valid work email.'); return; }
      if (ok && !ok.checked) { e.preventDefault(); fail(d.errConsent || 'Please confirm you are buying on behalf of a business.'); return; }

      /* Serialise the dynamic EAN lines into contact[body] — Shopify's contact
         form accepts a single message body, so the table is flattened to text. */
      var rows = [], filled = 0;
      lines.querySelectorAll('.qline').forEach(function (l) {
        var v = l.querySelectorAll('.qin');
        var ean = v[0].value.trim(), target = v[1].value.trim(), qty = v[2].value.trim();
        if (ean && qty) { filled++; rows.push('EAN ' + ean + ' | target £' + (target || 'n/a') + ' | qty ' + qty); }
      });
      if (!filled) { e.preventDefault(); fail(d.errLines || 'Add at least one line with an EAN and a quantity.'); return; }

      var notes = document.getElementById('rq_notes');
      var when  = document.getElementById('rq_when');
      if (body) {
        body.value =
          'QUOTE REQUEST (' + filled + ' lines)\n\n' + rows.join('\n') +
          '\n\nTimeframe: ' + ((when && when.value) || 'not stated') +
          '\nNotes: ' + ((notes && notes.value.trim()) || 'none');
      }
      /* not prevented -> Shopify posts the form and emails the store contact address */
    });

    refresh();
  }

  /* ---------------- Trade account form: client-side validation -------------- */
  function initAccount() {
    var form = document.getElementById('tradeForm');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); }
    });
  }

  /* ---------------- Header quote count on pages without the quote form ---- */
  function initQuoteBadge() {
    if (document.getElementById('qlines')) return;
    var badge = document.getElementById('quoteCount');
    if (!badge) return;
    try {
      var list = JSON.parse(localStorage.getItem('ttd_quote') || '[]');
      badge.textContent = String(list.length);
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBrands(); initRequest(); initAccount(); initQuoteBadge();
  });
})();
